import React, { Suspense } from 'react';
import { CircularProgress, Box } from '@mui/material';

interface I18nProviderProps {
  children: React.ReactNode;
}

const LoadingFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
  >
    <CircularProgress />
  </Box>
);

const I18nProvider = ({ children }: I18nProviderProps) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

export default I18nProvider; 